import React, { Component } from 'react'
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import { connect } from 'react-redux';
import { MdHelp, MdKeyboardArrowLeft, MdSettings, MdCheck, MdDelete } from 'react-icons/md';
import { Link } from 'react-router-dom'
import { Spinner, Button } from 'react-bootstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {
	Row,
	Col,
	Card,
	CardHeader,
	CardBody,
	Form,
	FormGroup,
	Alert,
	Badge
} from 'reactstrap';
import defaultUserImage from '../../../../src/assets/img/users/default-user-image.png'; 
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";


class AdminTicketDetailComponent extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			error: false,
			messageError: '',
			isNotification: false,
			textNotification: '',
			isSpinner: false,
			ticketId: 0,
			title: '',
			content: '',
			status: '',
			user_id: '',
			user_name: '',
			user_avatar: '',
			dateCreated: '',
			ticketDetailLists: [],
			comment: ''
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.ticketDetail(this.props.ticketId);
		this.setState({
			isNotification: this.props.isNotification,
			textNotification: this.props.textNotification,
		})
		if ( this.props.isNotification ) {
			this.props.notification({
				isNotification: false,
				textNotification: ''
			});
		}
	}

	ticketDetail = (ticketId) => {
		this.setState({
			isLoading: true
		});
		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			},
		  	params: { id: ticketId }
		}

		axios.get( process.env.REACT_APP_API_URL + '/api/admin/ticket/detail', config)
		.then( (ref) => {
			// console.log(ref.data);
			if ( ref.data.error === 0 ) {
				this.setState({
                    title: ref.data.content.ticket.title,
					content: ref.data.content.ticket.content,
					status: ref.data.content.ticket.status,
                    ticketId: ref.data.content.ticket.id,
                    user_id: ref.data.content.ticket.user_id,
                    user_name: ref.data.content.ticket.user_name,
                    user_avatar: ref.data.content.ticket.user_avatar ? ref.data.content.ticket.user_avatar : defaultUserImage,
                    dateCreated: ref.data.content.ticket.dateCreated,
                    ticketDetailLists: ref.data.content.ticketDetailLists,
                    isLoading: false,
					error: false,
					messageError: '',
				});
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						isLoading: false,
						error: true,
						messageError: ref.data.message,
					});
					this.redirectBack(ref.data.message);
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				error: true,
				isLoading: false,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
	}

    redirectBack = (message) => {
        this.props.notification({
            isNotification: true,
            textNotification: message
        });
        this.props.shouldRedirect();
    }

	checkNotification = () => {
		if ( this.state.isNotification ) {
			return (
				<Alert color="success">{ this.state.textNotification } </Alert>
				);
		}
	}

	change = (e) => {
		this.setState({
			[e.target.name]: e.target.value
		})
	}

	confirmChangeStatus = (status) => {
		confirmAlert({
	      	title: '',
	      	message: 'Bạn muốn thực hiện hành động này?',
	      	buttons: [
		        {
		          	label: 'Xác nhận',
		          	onClick: () => {
		          		this.changeStatus(status);
		          	}
		        },
		        {
		          	label: 'Hủy',
		          	onClick: () => false
		        }
	      	]
	    });
	}

	changeStatus = (status) => {
		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			},
		  	params: { id: this.state.ticketId, status: status }
		}

		axios.get( process.env.REACT_APP_API_URL + '/api/admin/ticket/change-status', config)
		.then( (ref) => {
			if ( ref.data.error === 0 ) {
				this.setState({
					isNotification: true,
					textNotification: ref.data.message,
					isLoading: false,
					error: false,
					messageError: '',
				});
				this.ticketDetail(this.state.ticketId);
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				error: true,
				isLoading: false,
				messageError: 'Lấy dữ liệu thất bại',
			})
		});
	}

	loadBadge = (status) => {
		if ( status === 'Pending' ) {
            return (
            	<Badge color="warning">Đang chờ xử lý</Badge>
            )
        }
        else if (status === 'Done') {
            return (
            	<Badge color="success">Xử lý hoàn tất</Badge>
            );
        }
        else if (status === 'Processing') {
            return (
            	<Badge color="info">Đang xử lý</Badge>
            );
        }
        else if (status === 'Cancel') {
            return (
            	<Badge color="danger">Đã hủy</Badge>
            );
        }
	}

	reply = () => {
		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			},
		  	params: { id: this.state.ticketId, content: this.state.comment }
		}

		axios.get( process.env.REACT_APP_API_URL + '/api/admin/ticket/reply', config)
		.then( (ref) => {
			if ( ref.data.error === 0 ) {
				this.setState({
					isNotification: true,
					textNotification: ref.data.message,
					comment: '',
					isLoading: false,
					error: false,
					messageError: '',
				});
				this.ticketDetail(this.state.ticketId);
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				error: true,
				isLoading: false,
				messageError: 'Lấy dữ liệu thất bại',
			})
		});
	}

	deleteCommentConfirm = (id) => {
		confirmAlert({
	      	title: '',
	      	message: 'Bạn muốn xóa phản hồi này?',
	      	buttons: [
		        {
		          	label: 'Xác nhận',
		          	onClick: () => {
		          		this.deleteComment(id);
		          	}
		        },
		        {
		          	label: 'Hủy',
		          	onClick: () => false
		        }
	      	]
	    });
	}

	deleteComment = (id) => {
		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			},
		  	params: { id: id }
		}

		axios.get( process.env.REACT_APP_API_URL + '/api/admin/ticket/delete-comment', config)
		.then( (ref) => {
			if ( ref.data.error === 0 ) {
				this.setState({
					isNotification: true,
					textNotification: ref.data.message,
					isLoading: false,
					error: false,
					messageError: ''
				});
				this.ticketDetail(this.state.ticketId);
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				error: true,
				isLoading: false,
				messageError: 'Lấy dữ liệu thất bại',
			})
		});
	}

	loadTicketDetailLists = () => {
		if ( this.state.ticketDetailLists.length ) {
            return (
                this.state.ticketDetailLists.map( (ticketDetail, key) => {
                    return (
                        <div className="post" key={key}>
							<div className="user-block">
                                {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
								<img src={ ticketDetail.user_avatar ? ticketDetail.user_avatar : defaultUserImage } alt="user image" className="img-circle img-bordered-sm" />
								<span className="username">
									<Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + ticketDetail.user_id }>{ ticketDetail.user_name }</Link>
								</span>
								<span className="description">Gửi vào lúc: { ticketDetail.dateCreated }</span>
							</div>
							<div style={{ 'display': 'inline-flex' }}>
								<div dangerouslySetInnerHTML={{ __html: ticketDetail.content }} />
								<OverlayTrigger
			                        key={key}
							      	placement='top'
							      	overlay={
							        	<Tooltip id={`ticket-detail-${key}`}>
								          	Xóa
								        </Tooltip>
							      	}
			                    >
				                    <span className="text-danger ml-3" style={{ 'cursor': 'pointer' }}
				                    	
				                    >
										<MdDelete onClick={ () => this.deleteCommentConfirm(ticketDetail.id) } />
									</span>
								</OverlayTrigger>
							</div>
						</div>
                    )
                })
            );
        }
	}

	render() {
		return (
			<>
				<Breadcrumb title={"Ticket Detail"} page={"icket Detail"} icon={<MdHelp className="breadcrumb-icon" />} />
				<Row style={{ marginTop: 20 }}>
					<Col sm={12}>
						{ this.state.error ? (<Alert color="danger"><div className='text-center'>{ this.state.messageError }</div></Alert>) : (<></>)}
						{this.checkNotification()}
					</Col>
				</Row>
				{
					this.state.isLoading ? (
						<div className="text-center">
			     			<Spinner animation="grow" variant="primary" />
			                <Spinner animation="grow" variant="secondary" />
			                <Spinner animation="grow" variant="success" />
			                <Spinner animation="grow" variant="danger" />
			                <Spinner animation="grow" variant="warning" />
			                <Spinner animation="grow" variant="info" />
			            </div>
					) : (
						<Form onSubmit={ this.saveSystemEmail }>
							<Row>
								<Col sm={12}>
									<Card>
										<CardHeader>
											<Link className="btn btn-outline-primary btn-sm" to={'/admin/ticket'}>
												<MdKeyboardArrowLeft /> Danh sách ticket
											</Link>
											{
												this.state.status !== 'Done' ? (
													<Button 
								    					className="btn btn-success btn-sm m-1"
														onClick={ () => this.confirmChangeStatus('Done') }
													>
														<MdCheck /> Xử lý hoàn tất
												  	</Button>
												) : (<></>)
											}
										</CardHeader>
										<CardBody>
											<h5>{ this.state.title } { this.loadBadge(this.state.status) }</h5>
											<div className="post">
												<div className="user-block">
                                                    {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
													<img src={ this.state.user_avatar } alt="user image" className="img-circle img-bordered-sm" />
													<span className="username">
														<Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.state.user_id }>{ this.state.user_name }</Link>
													</span>
													<span className="description">Gửi vào lúc: { this.state.dateCreated }</span>
												</div>
												<div>{ this.state.content }</div>
											</div>

											{ this.loadTicketDetailLists() }

											<div>
												{
													this.state.status === 'Processing' ? (
														<>
															<FormGroup>
											                  	<CKEditor
											                  		id="content"
											                  		name="content"
											                  		config={{
											                  			placeholder: "Nhập nội dung phản hồi ..."
											                  		}} 
												                    editor={ ClassicEditor }
												                    data={ this.state.comment }
												                    onChange={ ( event, editor ) => {
												                        const data = editor.getData();
												                        this.setState({
												                        	comment: data
												                        })
												                    } }
												                />
											                </FormGroup>
															<Button 
										    					className="btn btn-primary btn-sm"
																onClick={ () => this.reply() }
															>
																Phản hồi
														  	</Button>
														</>
													) : (<></>)
												}
											</div>
											<div>
												{
													this.state.status === 'Pending' ? (
														<Button 
									    					className="btn btn-primary btn-sm"
															onClick={ () => this.confirmChangeStatus('Processing') }
														>
															<MdSettings /> Tiến hành xử lý
													  	</Button>
													) : (<></>)
												}
											</div>
										</CardBody>
									</Card>
								</Col>
							</Row>
						</Form>
					)
				}
				
			</>	
		)
	}
}

const mapStateToProps = (state) => {
	return {
		token: state.login.token,
		isNotification: state.adminMain.isNotification,
		textNotification: state.adminMain.textNotification,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		logOut: () => {
			dispatch(({ type : 'logOut', page: 'AdminDetailTicket' }))
		},
		notification: (item) => {
			dispatch(({ type : 'notification', item }))
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminTicketDetailComponent);